import VehicleTransactionsHtml from './templates/vehicle-transactions.html';

export function VehicleTransactionsDirective () {
  return {
    controller: 'VehicleTransactionsCtrl',
    restrict: 'E',
    templateUrl: VehicleTransactionsHtml,
    scope: {
      vehicle: '=',
      transactions: '='
    }
  }
}

